import styled from 'styled-components'

// Shared across ShowPosts, PostComments, PostForm, and Vote.
export const Markdown = styled.div`
  p { margin: 0.25rem 0; }
  p:first-child { margin-top: 0; }
  p:last-child { margin-bottom: 0; }
  code {
    background: ${({ theme: { colors } }) => colors('chrome')};
    padding: 0.1rem 0.3rem;
    border-radius: 0.25rem;
    font-size: 0.85em;
  }
  pre {
    background: ${({ theme: { colors } }) => colors('chrome')};
    padding: 0.5rem;
    border-radius: 0.25rem;
    overflow-x: auto;
    code { background: none; padding: 0; }
  }
  ul, ol { padding-left: 1.25rem; margin: 0.25rem 0; }
  blockquote {
    margin: 0.25rem 0 0.25rem 0.5rem;
    padding-left: 0.5rem;
    border-left: 3px solid ${({ theme: { colors } }) => colors('chrome')};
    opacity: 0.8;
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: flex-start;
`

export const Action = styled.div`
  ${({ theme: { colors } }) => `
  background: ${colors('chrome')};
  border-radius: 0.5rem;
  color: ${colors('text')};
  display: flex;
  font-size: 1rem;
  align-items: center;
  align-content: flex-start;
  justify-content: flex-start;
  width: auto;
  margin: 0.5rem 1rem 0 0;
  padding: 0.5rem;
  svg:first-child{
    margin: 0 0.5rem 0 0;
  }
  svg:last-child{
    margin: 0 0 0 0.5rem;
  }
`}
`

// Extended by PostForm's PostBox, rendered directly by ShowPosts.
export const Post = styled.div`
  ${({ theme: { button, colors } }) => `
  background: ${colors('background')};
  border: 1px solid ${colors('chrome')};
  border-radius: ${button?.main?.radius || '0.15rem'};
  overflow: auto;
  margin: 1rem 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .body {
    padding: 0.5rem 0 0;
  }
`}
`

// Pre-existing dead code (not referenced anywhere) — preserved as-is, not this
// task's call to remove.
export const ModalOverlay = styled.div`
  ${({ $show, theme: { colors } }) => `
  display: ${$show ? 'block' : 'none'};
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background: ${colors('chrome', 0.25)};
  backdrop-filter: blur(4px);
  z-index: 1;
  `}
`
